import React, { FC, useState } from 'react';
import styled from '@emotion/styled';
import Button from '~ComponentsImproved/Button';
import { useI18n } from '~Hooks';
import DateTimePicker from '~ComponentsImproved/DateTimePicker';
import { useCart } from '~Components/CartProvider';

const Wrapper = styled.div`
  background-color: white;
  border-radius: 16px;
`;

const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;
  animation: fade-in 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
  position: relative;
`;

const Title = styled.div`
  text-align: center;
  color: var(--colorBlueGray1300);
  font-size: 28px;
  font-weight: bold;
  padding: 40px 48px;
  font-size: 32px;
  letter-spacing: 0.48px;
  line-height: 32px;
`;

const ButtonsWrapper = styled.div`
  padding: 16px;
  text-align: center;
  display: flex;
  margin-top: 36px;
  gap: 8px;
`;

interface Props {
  onClose: () => void;
}

/** Interface for setting desired time in QSR */
const DesiredTime: FC<Props> = ({ onClose }) => {
  const { i18n } = useI18n();
  const cart = useCart();

  const [date, setDate] = useState<string | null>(cart.desiredTime);

  const onSave = () => {
    cart.setDesiredTime(date);
    onClose();
  };

  return (
    <Wrapper>
      <Content>
        <Title>{i18n('DesiredTime.Title.Choose')}</Title>

        <DateTimePicker time={date} onChange={setDate} />

        <ButtonsWrapper>
          <Button
            styleType="Dark"
            text={i18n('General.Cancel')}
            width="160px"
            onTouchStart={onClose}
          />
          <Button styleType="OK" text={i18n('General.Submit')} onTouchStart={onSave} />
        </ButtonsWrapper>
      </Content>
    </Wrapper>
  );
};

export default DesiredTime;
